import { StoryEntity } from '@/shared/lib/db'
import { create } from 'zustand'

type FeatureEnabled = {
    nodeToolbar: boolean
}

interface StEditorState {
    storyEntity: StoryEntity | undefined
    setStoryEntity: (storyEntity: StoryEntity | undefined) => void
    featuresEnabled: FeatureEnabled
    updateFeatureEnabled: (feature: FeatureEnabled) => void
}

export const useStEditorStore = create<StEditorState>((set) => {
    // Initialize featuresEnabled from localStorage
    const storedFeatures = localStorage.getItem('stFeaturesEnabled')
    const initialFeatures: FeatureEnabled = storedFeatures
        ? JSON.parse(storedFeatures)
        : { nodeToolbar: false }

    return {
        storyEntity: undefined,
        setStoryEntity: (storyEntity) => set({ storyEntity }),
        featuresEnabled: initialFeatures,
        updateFeatureEnabled: (feature) => {
            localStorage.setItem('stFeaturesEnabled', JSON.stringify(feature))
            set({ featuresEnabled: feature })
        },
    }
})

// Hook for backward compatibility and simpler usage in components
export const useStEditorProvider = () => {
    return useStEditorStore()
}
